// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.children__KMJdjNw3m9{max-height:0;overflow:hidden}.childrenIsOpen__dZDyhWFo5f{max-height:none;overflow:visible}`, "",{"version":3,"sources":["webpack://./src/assets/fable/toggleBox/toggleBox.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,eAAA,CAEA,4BACE,eAAA,CACA,gBAAA","sourcesContent":[".children {\n  max-height: 0;\n  overflow: hidden;\n\n  &IsOpen {\n    max-height: none;\n    overflow: visible;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"children": `children__KMJdjNw3m9`,
	"childrenIsOpen": `childrenIsOpen__dZDyhWFo5f`
};
export default ___CSS_LOADER_EXPORT___;
